(function($) {
	'use strict';

	$.widget('msv.googlemap', {

		options: {
			markerMyLocation: "/assets/images/my-location.png",
			markerNewSearch: "/assets/images/new-search.png",
			styles: [
				{ "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#e9e9e9" }, { "lightness": 17 }] }, {
					"featureType": "landscape",
					"elementType": "geometry",
					"stylers": [{ "color": "#f5f5f5" }, { "lightness": 20 }]
				}, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }, { "lightness": 17 }] }, {
					"featureType": "road.highway",
					"elementType": "geometry.stroke",
					"stylers": [{ "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 }]
				}, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 18 }] }, {
					"featureType": "road.local",
					"elementType": "geometry",
					"stylers": [{ "color": "#ffffff" }, { "lightness": 16 }]
				}, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 21 }] }, {
					"featureType": "poi.park",
					"elementType": "geometry",
					"stylers": [{ "color": "#dedede" }, { "lightness": 21 }]
				}, { "elementType": "labels.text.stroke", "stylers": [{ "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 }] }, {
					"elementType": "labels.text.fill",
					"stylers": [{ "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 }]
				}, { "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, {
					"featureType": "transit",
					"elementType": "geometry",
					"stylers": [{ "color": "#f2f2f2" }, { "lightness": 19 }]
				}, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#fefefe" }, { "lightness": 20 }] }, {
					"featureType": "administrative",
					"elementType": "geometry.stroke",
					"stylers": [{ "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 }]
				}
			]
		},

		_create: function() {
			this.getMyLocation();
		},
		focusMarkerById: function(id) {
			var self = this;
			self.markers.forEach(function(marker) {
				if (id == marker.id) {
					google.maps.event.trigger(marker, 'click');
					return;
				}
			});
		},
		fitBounds: function() {
			var self = this;

			var bounds = new google.maps.LatLngBounds();
			for (var i = 0; i < self.markers.length; i++) {
				bounds.extend(self.markers[i].getPosition());
			}

			self.map.fitBounds(bounds);
		},
		getMyLocation: function() {
			var self = this;

			//Default Position : Luanda
			self.myposition = {
				lat: -8.8535258,
				lng: 13.2140645
			};

			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(function(position) {
					// console.log(position);
					self.myposition = {
						lat: position.coords.latitude,
						lng: position.coords.longitude
					};
					self.getAllAgencies();
				}, function(e) {

					self.getAllAgencies();
					// console.log('Browser has GeoLocation but something is missing...');
				});
			}
			else {
				// console.log('Something is missing...');
			}

			//if (BEC.context && BEC.context == "ondeestamos") {
			self.getAllAgencies();
			self.getAllLocations();
			self.getAllAgenciesTypes();
			self.mobileEvents();
			if (BEC.context && BEC.context == "ondeestamos")
				self.targetToCenterEvent();

			//};
		},

		getAllAgencies: function(lat, lng) {
			var self = this;
			var endpoint = $(self.element).data('agencies');
			$.getJSON(endpoint, self.myposition, function(incoming) {
				self.options.allPoints = incoming;
				BEC.locations = incoming;
				self.locations = incoming;
				self.drawMap(self.options.allPoints);
				if (BEC.context && BEC.context == "ondeestamos") {
					self.addList(self.options.allPoints);
					self.searchInputEvents(self.options.allPoints);
				}
				var myLatLon = new LatLon(self.myposition.lat, self.myposition.lng);
				$.each(self.locations, function(index, value) {
					var locationLatLon = new LatLon(value.coords.lat, value.coords.lng);
					self.locations[index].distance = Math.round(myLatLon.distanceTo(locationLatLon));
				});
				self.locations = _.sortBy(self.locations, ['distance']);
			});
		},

		getAllLocations: function() {
			var self = this;
			var endpoint = $(self.element).data('locations');
			$.getJSON(endpoint, function(incoming) {
				self.options.allLocations = incoming;
				if (self.options.allAgenciesTypes) {
					self.loadSelects();
				}
			});
		},

		getAllAgenciesTypes: function() {
			var self = this;
			var endpoint = $(self.element).data('agencies-tags');
			$.getJSON(endpoint, function(incoming) {
				self.options.allAgenciesTypes = incoming;
				if (self.options.allLocations) {
					self.loadSelects();
				}
			});
		},

		drawMap: function() {
			var self = this;

			self.map = new google.maps.Map(document.getElementById('map__canvas'), {
				zoom: 13,
				center: self.myposition,
				styles: this.options.styles,
			});

			self.iconMyLocation = {
				url: this.options.markerMyLocation,
				size: new google.maps.Size(70, 70),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(35, 35)
			};

			self.iconNewSearch = {
				url: this.options.markerNewSearch,
				size: new google.maps.Size(100, 100),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(50, 50)
			};

			self.iconMarkerAgency = {
				url: BEC.markerAgency,
				size: new google.maps.Size(50, 70),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(30, 30)
			};

			self.markers = [];
			self.globalwindow = null;
			self.globalwindowMylocation = null;

			if (self.myposition) self.myLocationEvents();

			self.addMarkers();
			self.addClusters();

			self.map.addListener('click', function() {
				if (self.globalwindow) {
					self.globalwindow.close();
				}
				if (self.globalwindowMylocation) {
					self.globalwindowMylocation.close();
				}

			});

			google.maps.event.addListener(self.map, 'click', function(args) {
				var closestMarker = { marker: null, distance: null };

				self.markers.forEach(function(marker) {
					var distance = google.maps.geometry.spherical.computeDistanceBetween(marker.position, args.latLng);
					if (!closestMarker.marker || closestMarker.distance > distance) {
						closestMarker.distance = distance;
						closestMarker.marker = marker;
					}
				});


				var getClicableDistance = function(z) {
					var mapClickableDistance = { 5: 132000, 8: 16000, 11: 2300, 14: 600, 19: 12 };

					var maxKey = 5;
					for (var k in mapClickableDistance) {
						k = parseInt(k);
						if (k <= z && maxKey <= k)
							maxKey = k;
					}

					return mapClickableDistance[maxKey];
				}

				if (closestMarker.marker && closestMarker.distance < getClicableDistance(closestMarker.marker.map.zoom))
					google.maps.event.trigger(closestMarker.marker, 'click');
			});
		},

		myLocationEvents: function() {
			var self = this;

			//customized infowindow mylocation
			var contentMyLocation = '<div class="infowindow-mylocation">' + BEC.dictionary["you-are-here"] + '</div>';

			var infowindowMyLocation = new google.maps.InfoWindow({
				content: contentMyLocation,
				maxWidth: 350
			});

			google.maps.event.addListener(infowindowMyLocation, 'domready', function() {

				var iwOuter = $('.gm-style-iw');
				var iwOuterChild = iwOuter.children(':first');
				var iwBackground = iwOuter.prev();
				var iwScroll = $('.info-window-container');


				iwOuter.parent().parent().css({ left: '0px' });
				iwOuter.parent().addClass('parent_infowindow-mylocation');
				iwOuterChild.css('overflow', 'inherit');
				iwScroll.css({ 'overflow': 'auto', 'max-height': '250px' });
				iwBackground.children(':nth-child(2)').css({ 'display': 'none' });
				iwBackground.children(':nth-child(4)').css({ 'display': 'none' });
				iwBackground.css({ 'z-index': '4', 'position': 'relative', 'height': '100%' });
				iwBackground.children(':nth-child(1)').attr('style', function(i, s) {
					return s + 'display: none !important;'
				});

				iwBackground.children(':nth-child(3)').addClass('tooltip-gm-mylocation');
				iwBackground.children(':nth-child(3)').find('div').children().css({ 'display': 'none' });
				var iwCloseBtn = iwOuter.next();
				iwCloseBtn.css('display', 'none');
			});

			//marker my location events

			self.markerMyLocation = new google.maps.Marker({
				position: self.myposition,
				map: self.map,
				icon: self.iconMyLocation
			});

			google.maps.event.addListener(self.markerMyLocation, 'click', function() {
				if (self.globalwindow) {
					self.globalwindow.close();
				}

				infowindowMyLocation.open(self.map, self.markerMyLocation);
				self.map.setZoom(14);

				self.map.panTo(self.markerMyLocation.getPosition());
				self.globalwindowMylocation = infowindowMyLocation;

			});

			//open infowindow my location
			google.maps.event.trigger(self.markerMyLocation, 'click');

		},

		addMarkers: function() {
			var self = this;

			$.each(this.options.allPoints, function(i, el) {

				//markers infowindow content

				var centroEmpresasTag = "";
				var centroPrivateTag = "";
				var balcaoTag = "";
				var btnCta = "";
				var _tags = "";

				for (var j = 0; j < el.tags.length; j++) {

					_tags += "<div class='info-window-container__tag-container__item'>" + el.tagObjects[j].name + "</div>"
				}

				if (BEC.context && BEC.context == "ondeestamos") {
					btnCta = '<div class="btn btn-purple btn-info-window js-ripple-btn"><a href="https://maps.google.com?saddr=Current+Location&daddr=' + el.coords.lat + ',' + el.coords.lng + '" target="_blank">Obter direcções</a></div>'
				}
				else {
					btnCta = ''; //'<div class="btn btn-purple btn-info-window js-ripple-btn">Saiba mais</div>'
				}

				var content = '<div class="info-window-container__tag-container">' + _tags + '</div>' +
					'<div class="info-window-container">' +
					'<div class="info-window-container__title">' + el.name + '</div>' +
					'<div class="info-window-container__schedule">Horário: ' + el.schedule + '</div>' +
					'<div class="info-window-container__address">' + el.address + '</div>' +
					'<span class="info-window-container__phone">Tel.: ' + el.phone + '</span><span class="info-window-container__cellphone">/ Móvel: ' + el.cellphone + '</span>' +
					'<div class="info-window-container__fax">Fax: ' + el.fax + '</div>' + btnCta +
					'</div>';

				//set infowindow 

				var infowindow = new google.maps.InfoWindow({
					content: content,
					maxWidth: 350

				});

				// set / reset default styles infowindow

				google.maps.event.addListener(infowindow, 'domready', function() {

					var iwOuter = $('.gm-style-iw');
					var iwOuterChild = iwOuter.children(':first');
					var iwBackground = iwOuter.prev();
					var iwScroll = $('.info-window-container');

					iwOuter.parent().parent().css({ left: '0px' });
					iwOuter.parent().addClass('parent_infowindow');
					iwOuterChild.css('overflow', 'inherit');
					iwScroll.css({ 'overflow': 'auto', 'max-height': '250px' });
					iwBackground.children(':nth-child(2)').css({ 'display': 'none' });
					iwBackground.children(':nth-child(4)').css({ 'display': 'none' });
					iwBackground.css({ 'z-index': '4', 'position': 'relative', 'height': '100%' });
					iwBackground.children(':nth-child(1)').attr('style', function(i, s) {
						return s + 'display: none !important;'
					});
					iwBackground.children(':nth-child(3)').addClass('tooltip-gm');
					/* iwBackground.children(':nth-child(3)').attr('style', function(i, s) {
					    return s + 'bottom:-46px; background-image: url("/assets/images/tooltip.png"); width:25px; height:20px; margin-left:12px; top: initial;'

					 });*/
					iwBackground.children(':nth-child(3)').find('div').children().css({ 'display': 'none' });
					var iwCloseBtn = iwOuter.next();
					iwCloseBtn.addClass('map__icon-cross');
					iwCloseBtn.find('img').css('display', 'none');
					$('.info-window-container__tag-container').click(function() {
						infowindow.close();
					});
					iwCloseBtn.click(function() {
						infowindow.close();
					});
				});

				//set Markers

				var marker = new google.maps.Marker({
					position: self.options.allPoints[i].coords,
					map: self.map,
					icon: self.iconMarkerAgency
				});

				marker.setValues({ type: "point", id: el.id });

				google.maps.event.addListener(marker, 'click', function() {
					if (self.globalwindow) {
						self.globalwindow.close();
					}

					if (self.globalwindowMylocation) {
						self.globalwindowMylocation.close();
					}

					infowindow.close();

					infowindow.open(self.map, marker);
					self.map.setZoom(14);

					self.map.panTo(marker.getPosition());
					self.globalwindow = infowindow;

				});

				self.markers.push(marker);
			});
		},

		addClusters: function() {
			var self = this;

			self.mcOptions = {
				gridSize: 50,
				maxZoom: 15,
				styles: [{
					anchorText: [-8, 0],
					width: 44,
					height: 62,
					url: '/assets/images/agency_cluster.png',
					textColor: '#632d81',
					textSize: 14
				}]
			};

			self.markerCluster = new MarkerClusterer(self.map, self.markers, self.mcOptions);
			self.markerCluster.setIgnoreHidden(true);
		},

		addList: function() {
			var self = this;
			var listContainer = $('.map-full__search__container');
			var listContainerParent = $('.map__search');
			var btnToggleList = $('.btn-lista');


			listContainer.empty();

			$.each(this.options.allPoints, function(i, el) {
				var listItem = "";
				var _tags = "";
				var btnCta = "";

				for (var j = 0; j < el.tags.length; j++) {
					if (el.tagObjects)
						_tags += "<div class='map-full__search__container__item__tag-container__item'>" + el.tagObjects[j].name + "</div>"
					// console.log(_tags)
				}
				if (BEC.context && BEC.context == "ondeestamos") {
					btnCta = '<div class="btn btn-purple btn-info-window js-ripple-btn"><a href="https://maps.google.com?saddr=Current+Location&daddr=' + el.coords.lat + ',' + el.coords.lng + '" target="_blank">Obter direcções</a></div>'
				}
				else {
					btnCta = ''; //'<div class="btn btn-purple btn-info-window js-ripple-btn">Saiba mais</div>'
				}

				listItem = $("<div class='map-full__search__container__item' id='" + el.id + "'' data-location='" + el.location + "'><div class='map-full__search__container__item__tag-container'>" + _tags + "</div><div class='map-full__search__container__item__title'>" + el.name + "</div><div class='map-full__search__container__item__schedule'>Horário: " + el.schedule + "</div><div class='map-full__search__container__item__address'>" + el.address + "</div><span class='map-full__search__container__item__phone'>Tel.: " + el.phone + "</span><span class='map-full__search__container__item__cellphone'>/ Móvel: " + el.cellphone + "</span><div class='map-full__search__container__item__fax'>Fax: " + el.fax + "</div>" + btnCta + "</div>");

				listItem.click(function() {

					listContainerParent.removeClass('opened');
					btnToggleList.find('span').html('Ver em lista');


					for (var j = 0; j < self.options.allPoints.length; j++) {
						if (self.markers[j].id == el.id) {
							google.maps.event.trigger(self.markers[j], 'click');
						}
					}

				});

				listContainer.append(listItem);

				if (i == self.options.allPoints.length - 3) {
					self.myScroll = new IScroll('.map__search', {
						mouseWheel: true,
						scrollbars: false
					});
				}
			});




		},

		loadSelects: function() {
			var self = this;


			//setup locations Select
			var locationsSelectContainer = $('.map-full__filters-container__menu__select.location');
			self.locationsSelectTrigger = $('.map-full__filters-container__menu__item.location');

			var allLocationsItem = $('.form-datalist-item.all-locations');
			allLocationsItem.click(function() {
				var _this = $(this);
				self.locationsSelectTrigger.find('span').html(self.locationsSelectTrigger.find('span').data('name'));
				self.locationsSelectTrigger.find('span').data('id', _this.data('id'));

				if (window.innerWidth > 960) {
					self.filterLists("", "tag=" + self.agenciesSelectTrigger.find('span').data('id'));

				}

				self.locationsSelectTrigger.removeClass('opened');
				locationsSelectContainer.removeClass('opened');
			});


			$.each(this.options.allLocations, function(i, el) {

				var selectItem = $("<div class='form-datalist-item' data-id='" + el.id + "'>" + el.name + "</div>");

				selectItem.click(function() {

					self.locationsSelectTrigger.find('span').html(el.name);
					self.locationsSelectTrigger.find('span').data('id', el.id);

					if (window.innerWidth > 960) {
						self.filterLists("location=" + el.id, "&tag=" + self.agenciesSelectTrigger.find('span').data('id'));
						if (i == self.options.allLocations.length - 1) {
							self.myScroll = new IScroll('.map-full__filters-container__menu__select.location', {
								mouseWheel: true,
								scrollbars: false
							});
						}
					}

					self.locationsSelectTrigger.removeClass('opened');
					locationsSelectContainer.removeClass('opened');
				});

				locationsSelectContainer.find('.form-datalist__options').append(selectItem);
			});

			self.locationsSelectTrigger.click(function() {
				self.locationsSelectTrigger.toggleClass('opened');
				locationsSelectContainer.toggleClass('opened');
				agenciesSelectContainer.removeClass('opened');
				self.agenciesSelectTrigger.removeClass('opened');

			});

			//setup agencies Select
			var agenciesSelectContainer = $('.map-full__filters-container__menu__select.agencies');
			self.agenciesSelectTrigger = $('.map-full__filters-container__menu__item.agencies');

			var allAgenciesItem = $('.form-datalist-item.all-agencies');
			allAgenciesItem.click(function() {
				var _this = $(this);
				self.agenciesSelectTrigger.find('span').html(self.agenciesSelectTrigger.find('span').data('name'));
				self.agenciesSelectTrigger.find('span').data('id', _this.data('id'));

				if (window.innerWidth > 960) {
					self.filterLists("location=" + self.locationsSelectTrigger.find('span').data('id'), "");
				}

				self.agenciesSelectTrigger.removeClass('opened');
				agenciesSelectContainer.removeClass('opened');
			});

			$.each(this.options.allAgenciesTypes, function(i, el) {

				var selectItem = $("<div class='form-datalist-item' data-id='" + el.id + "'>" + el.name + "</div>");


				selectItem.click(function() {

					self.agenciesSelectTrigger.find('span').html(el.name);
					self.agenciesSelectTrigger.find('span').data('id', el.id);

					if (window.innerWidth > 960) {
						self.filterLists("location=" + self.locationsSelectTrigger.find('span').data('id'), "&tag=" + el.id);
					}

					self.agenciesSelectTrigger.removeClass('opened');
					agenciesSelectContainer.removeClass('opened');
				});


				agenciesSelectContainer.find('.form-datalist__options').append(selectItem);
			});

			self.agenciesSelectTrigger.click(function() {
				self.agenciesSelectTrigger.toggleClass('opened');
				agenciesSelectContainer.toggleClass('opened');
				locationsSelectContainer.removeClass('opened');
				self.locationsSelectTrigger.removeClass('opened');

			});
		},

		refreshListScroll: function() {
			var self = this;
			setTimeout(function() {
				self.myScroll.refresh();

			}, 300);
		},


		filterLists: function(filter, secondFilter) {

			// console.log(filter, secondFilter)
			var self = this;
			var listContainer = $('.map-full__search__container');
			var allItems = listContainer.find('.map-full__search__container__item');

			allItems.removeClass('hide');

			var filterCoordinates = '';
			if (self.myposition && self.myposition.lng && self.myposition.lat)
				filterCoordinates = '&lat=' + self.myposition.lat + '&lng=' + self.myposition.lng;
			var endpoint = $(self.element).data('agencies') + "?" + filter + secondFilter + filterCoordinates;

			$.getJSON(endpoint, function(incoming) {
				self.options.allPoints = incoming;
				BEC.locations = incoming;
				self.locations = incoming;
				self.drawMap(self.options.allPoints);
				if (BEC.context && BEC.context == "ondeestamos") {
					self.addList(self.options.allPoints);
					self.searchInputEvents(self.options.allPoints);
				}
				var myLatLon = new LatLon(self.myposition.lat, self.myposition.lng);
				$.each(self.locations, function(index, value) {
					var locationLatLon = new LatLon(value.coords.lat, value.coords.lng);
					self.locations[index].distance = Math.round(myLatLon.distanceTo(locationLatLon));
				});
				self.locations = _.sortBy(self.locations, ['distance']);
			});

			self.selectedFirstFilter = filter;
			self.selectedSecondFilter = secondFilter;

			self.refreshListScroll();
		},

		targetToCenterEvent: function() {
			var btnTarget = $('.target-icon');
			var self = this;
			btnTarget.click(function() {
				self.map.panTo(self.myposition);
				google.maps.event.trigger(self.markerMyLocation, 'click');
				if (self.filtersMobileContainer) {
					self.filtersMobileContainer.removeClass('opened');
				}
			});


		},

		searchInputEvents: function() {
			var self = this;
			var input = document.getElementById('search-map-input');
			var inputMobile = document.getElementById('search-map-input_mobile');
			var newMarker;

			var autocomplete = new google.maps.places.Autocomplete(input, {
				types: ['geocode'],
				strictBounds: true
			});

			var autocompleteMobile = new google.maps.places.Autocomplete(inputMobile, {
				types: ['geocode'],
				strictBounds: true
			});

			autocomplete.bindTo('bounds', self.map);
			autocompleteMobile.bindTo('bounds', self.map);


			autocomplete.addListener('place_changed', function() {
				if (newMarker) {
					newMarker.setVisible(false);
					newMarker.setMap(null);
					if (self.globalwindow) {
						self.globalwindow.close();
					}
				};

				var place = autocomplete.getPlace();


				if (!place.geometry) {

					// window.alert("No details available for input: '" + place.name + "'");
					return;
				}

				var newPosition = place.geometry.location;

				newMarker = new google.maps.Marker({
					position: newPosition,
					map: self.map,
					icon: self.iconNewSearch
				});

				self.agenciesSelectTrigger.find('span').html(self.agenciesSelectTrigger.find('span').data('name'));
				self.agenciesSelectTrigger.find('span').data('id', "");
				self.locationsSelectTrigger.find('span').html(self.locationsSelectTrigger.find('span').data('name'));
				self.locationsSelectTrigger.find('span').data('id', "");


				self.filterLists("", "");


				var myLatLon = new LatLon(place.geometry.location.lat(), place.geometry.location.lng());
				$.each(self.locations, function(index, value) {
					var locationLatLon = new LatLon(value.coords.lat, value.coords.lng);
					self.locations[index].distance = Math.round(myLatLon.distanceTo(locationLatLon));
				});
				var closestLocation = _.sortBy(self.locations, ['distance']);
				self.options.allPoints = _.sortBy(self.locations, ['distance']);

				self.addList(self.options.allPoints);


				var indexOfClosestLocation = closestLocation[0].id;


				google.maps.event.trigger(self.markers[indexOfClosestLocation - 1], 'click');


				setTimeout(function() {
					if (place.geometry.viewport) {
						self.map.fitBounds(place.geometry.viewport);
					}
					else {
						self.map.setCenter(place.geometry.location);
						self.map.setZoom(17);
					}
				}, 800)


			});


			autocompleteMobile.addListener('place_changed', function() {

				if (newMarker) {
					newMarker.setVisible(false);
					newMarker.setMap(null);
				};

				if (self.globalwindow) {
					self.globalwindow.close();
				}

				var place = autocompleteMobile.getPlace();
				if (!place.geometry) {

					window.alert("No details available for input: '" + place.name + "'");
					return;
				}

				if (place.geometry.viewport) {
					self.map.fitBounds(place.geometry.viewport);
				}
				else {
					self.map.setCenter(place.geometry.location);
					self.map.setZoom(17);
				}

				var newPosition = place.geometry.location;

				newMarker = new google.maps.Marker({
					position: newPosition,
					map: self.map,
					icon: self.iconNewSearch
				});

				if (self.filtersMobileContainer) {
					self.filtersMobileContainer.removeClass('opened');
				}


				if ($('.map__search').hasClass('opened')) {

					$('.map__search').removeClass('opened')
					$('.btn-lista').find('span').html('Ver em lista');

					self.refreshListScroll();
				}


				self.agenciesSelectTrigger.find('span').html(self.agenciesSelectTrigger.find('span').data('name'));
				self.agenciesSelectTrigger.find('span').data('id', "");
				self.locationsSelectTrigger.find('span').html(self.locationsSelectTrigger.find('span').data('name'));
				self.locationsSelectTrigger.find('span').data('id', "");


				self.filterLists("", "");


				var myLatLon = new LatLon(place.geometry.location.lat(), place.geometry.location.lng());
				$.each(self.locations, function(index, value) {
					var locationLatLon = new LatLon(value.coords.lat, value.coords.lng);
					self.locations[index].distance = Math.round(myLatLon.distanceTo(locationLatLon));
				});
				var closestLocation = _.sortBy(self.locations, ['distance']);
				self.options.allPoints = _.sortBy(self.locations, ['distance']);

				self.addList(self.options.allPoints);

				var indexOfClosestLocation = closestLocation[0].id;

				google.maps.event.trigger(self.markers[indexOfClosestLocation - 1], 'click');

				setTimeout(function() {
					if (place.geometry.viewport) {
						self.map.fitBounds(place.geometry.viewport);
					}
					else {
						self.map.setCenter(place.geometry.location);
						self.map.setZoom(17);
					}
				}, 800)
			});

		},

		mobileEvents: function() {

			var self = this;
			//list events
			var btnToggleList = $('.btn-lista');
			var listContainer = $('.map__search');

			btnToggleList.click(function() {
				listContainer.toggleClass('opened');
				if (listContainer.hasClass('opened')) {
					btnToggleList.find('span').html('Ver no mapa');

					self.refreshListScroll();
				}
				else {
					btnToggleList.find('span').html('Ver em lista');
				}
			});

			//Filters events
			var btnToggleFilters = $('.map-full__filters-container .map-full__filters-container__mobile-placeholder');
			self.filtersMobileContainer = $('.map-full__filters-container__mobile-modal');
			var btnCancel = '<div class="btn btn-gray btn-cancel  js-ripple-btn">Cancelar</div>';
			var btnApplyFilters = '<div class="btn btn-blue btn-apply  js-ripple-btn">Aplicar Filtros</div>';


			$('.map-full__filters-container').clone().appendTo(self.filtersMobileContainer);

			var btnToggleFiltersOpened = self.filtersMobileContainer.find('.map-full__filters-container__mobile-placeholder');

			$("#search-map-input").attr('id', 'search-map-input_mobile');

			self.filtersMobileContainer.append(btnCancel);
			self.filtersMobileContainer.append(btnApplyFilters);


			btnCancel = self.filtersMobileContainer.find('.btn-cancel');
			btnApplyFilters = self.filtersMobileContainer.find('.btn-apply');


			btnToggleFilters.click(function() {
				self.filtersMobileContainer.addClass('opened');
			});

			btnToggleFiltersOpened.click(function() {
				self.filtersMobileContainer.removeClass('opened');
			});


			btnCancel.click(function() {
				self.filtersMobileContainer.removeClass('opened');

				self.locationsSelectTrigger.find('span').html(self.selectedFirstFilter);
				self.agenciesSelectTrigger.find('span').html(self.selectedSecondFilter)
			});

			btnApplyFilters.click(function() {
				self.filtersMobileContainer.removeClass('opened');
				self.filterLists("location=" + self.locationsSelectTrigger.find('span').html(), "&tag=" + self.agenciesSelectTrigger.find('span').html());
			});

		}



	});

})(jQuery);